// ShipListItem.tsx
import React, { useState } from 'react';
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Separator,
} from '@ais-ui/ui-core';
import { cn } from '@ais-ui/utils';
import { v4 as uuidv4 } from 'uuid';
import { DetailedShipList, ShipList } from '@ais-ui/api-spec/config';
import { DeleteShiplist } from '../Mutations/filter/DeleteShiplist';
import { EditShiplist } from '../Mutations/shiplist/EditShiplist';
import { ShipListItemContent } from './ShipListItemContent';
import { ShipListTable } from './ShipListTable';
import {
  ApplyShiplistAsFilterButton,
  ApplyShiplistAsColorButton,
} from './ShipListActionButtons';
import { ShipListDropdownMenu } from './ShipListDropdownMenu';

interface ShipListItemProps {
  shiplist: ShipList;
}

export const ShipListItem = ({ shiplist }: ShipListItemProps) => {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [showShips, setShowShips] = useState(false);
  const [detailedShiplist, setDetailedShiplist] = useState<
    DetailedShipList | undefined
  >();

  const onShowShips = (detailedShipList: DetailedShipList) => {
    setShowShips(true);
    setDetailedShiplist(detailedShipList);
  };

  const onDelete = () => {
    setShowDeleteDialog(true);
  };

  const onEdit = () => {
    setShowEditDialog(true);
  };

  return (
    <AccordionItem
      key={shiplist.id}
      value={shiplist.id ? shiplist.id : uuidv4()}
      className={cn('pr-4 pl-2')}
    >
      {showShips && detailedShiplist && (
        <ShipListTable
          detailedShiplist={detailedShiplist}
          showPopover={showShips}
          setShowPopover={setShowShips}
        />
      )}

      <div className="flex justify-between items-center">
        <div className="flex items-center">
          <div className="flex space-x-1 items-center">
            <ApplyShiplistAsFilterButton shiplist={shiplist} />
            <ApplyShiplistAsColorButton shiplist={shiplist} />
            <Separator orientation="vertical" className="h-6 bg-gray-300" />
          </div>

          <AccordionTrigger className="w-[205px]" hideChevron={true}>
            <div className="flex ml-4 space-x-2 items-center">
              <p className="text-sm text-left font-medium leading-none group-hover:underline">
                {shiplist.name
                  ? shiplist.name.length > 26
                    ? `${shiplist.name.substring(0, 26)}...`
                    : shiplist.name
                  : ''}
              </p>
            </div>
          </AccordionTrigger>
        </div>

        <ShipListDropdownMenu
          shiplist={shiplist}
          onShowShips={onShowShips}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      </div>

      <AccordionContent>
        <ShipListItemContent shiplist={shiplist} />
      </AccordionContent>

      {showDeleteDialog && (
        <DeleteShiplist
          shiplist={shiplist}
          showDialog={showDeleteDialog}
          setShowDialog={setShowDeleteDialog}
        />
      )}

      {showEditDialog && (
        <EditShiplist
          showDialog={showEditDialog}
          setShowDialog={setShowEditDialog}
          shiplist={shiplist}
        />
      )}
    </AccordionItem>
  );
};
